/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagGroup } from '../../models/tag-group';

export interface AdminFindTagGroupById$Params {
  id: string;
  includeTags?: boolean;
  nested?: boolean;
}

export function adminFindTagGroupById(http: HttpClient, rootUrl: string, params: AdminFindTagGroupById$Params, context?: HttpContext): Observable<StrictHttpResponse<TagGroup>> {
  const rb = new RequestBuilder(rootUrl, adminFindTagGroupById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('includeTags', params.includeTags, {});
    rb.query('nested', params.nested, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagGroup>;
    })
  );
}

adminFindTagGroupById.PATH = '/admin/tag-groups/{id}';
